import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import VnPagination from '@ui/components/VnPagination';
import { getAllActiveWorkOrderAsync, getAllJobCategoriesAsync, getAllWorkOrderAsync, getAllWorkOrderStatusAsync, getAllWorkOrdersDetailsAsync, getAllWorkOrdersOnMoveAsync } from '@application/features/workorders/workorderThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useNavigate } from 'react-router-dom';
import WorkOrderTable from './WorkOrderTable';
import ActiveWorkOrderTable from './ActiveWorkOrderTable';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import './../../../styles/style.css';
import WorkOrderOnMoveTable from './WorkOrderOnMoveTable';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import WorkOrderDetailsTable from './WorkOrderDetailsTable';
import LocalStorageService from '@infrastructure/local-storage-service';
import { RoleCategory } from '@application/common/enums/role-category';
import { addMonths } from 'rsuite/esm/internals/utils/date';
const WorkOrdersList = () => {
    VnDocumentTitle('Visser Werkorders');
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('Werkorders');
    const [showWorkOrderGridHeader] = useState(true);
    const { currentUser, currentEmployeeSettings } = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const { workOrders, workOrderRequest, ActiveworkOrders, activeWorkOrderRequest, workOrdersOnMove, workOrdersDetails } = useAppSelector((state) => state.workorder);
    const defaultSortingCriteria = {
        sortColumnKey: 'created',
        sortDirection: 'desc'
    };
    const defaultWorkorderFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        urgent: null,
        workOrderNumber: null,
        created: null,
        objectInside: null,
        debtorName: null,
        description: null,
        clientOrderNumber: null,
        workOrderCategory: null,
        workOrderStatus: null,
        desiredDeliveryDate: null,
        createdBy: null,
        debtorCity: null,
        from: addMonths(new Date(), -6),
        to: new Date(),
        locationId: 0
    };
    const defaultActiveWorkorderFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        urgent: null,
        workOrderNumber: null,
        created: null,
        objectInside: null,
        debtorName: null,
        description: null,
        clientOrderNumber: null,
        workOrderCategory: null,
        workOrderStatus: null,
        desiredDeliveryDate: null,
        createdBy: null,
        debtorCity: null,
        locationId: 0
    };
    const defaultOnMoveWorkorderFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        urgent: null,
        workOrderNumber: null,
        created: null,
        objectInside: null,
        debtorName: null,
        description: null,
        clientOrderNumber: null,
        workOrderCategory: null,
        workOrderStatus: null,
        desiredDeliveryDate: null,
        //createdBy: null,
        debtorCity: null,
        projectManagerIdentifier: null,
        locationId: 0
    };
    const defaultWorkordersDetailsFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        workOrderNumber: null,
        debtorName: null,
        objectInside: null,
        workOrderCategory: null,
        urgent: null,
        description: null,
        objectBrand: null,
        objectType: null,
        objectSerialNumber: null,
        objectCurrent: null,
        objectPower: null,
        objectRPM: null,
        clientOrderNumber: null,
        workOrderStatus: null,
        workOrderStatusOrder: null,
        technicalCompletionDate: null,
        deliveryNoteNumber: null,
        invoiceLinePosition: null,
        invoiceLineDescription: null,
        invoiceLineQuantity: null,
        invoiceLinePrice: null,
        objectClientReference: null,
        created: null,
        invoiceNumber: null,
        from: addMonths(new Date(), -6),
        to: new Date(),
        locationId: 0
    };
    const [workorderFilterValues, setWorkorderFilterValues] = useState(defaultWorkorderFilterValues);
    const [activeworkorderFilterValues, setActiveWorkorderFilterValues] = useState(defaultActiveWorkorderFilterValues);
    const [onMoveworkorderFilterValues, setonMoveWorkorderFilterValues] = useState(defaultOnMoveWorkorderFilterValues);
    const [workordersDetailsFilterValues, setWorkordersDetailsFilterValues] = useState(defaultWorkordersDetailsFilterValues);
    const handleAddWorkOrderClick = () => {
        navigate(`/admin/WorkordersTabs`);
    };
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    const onRowClick = (rowId) => {
        window.open(`/admin/WorkordersTabs/${rowId}`, '_blank');
    };
    useEffect(() => {
        const rolePermissions = LocalStorageService.getRolePermission();
        if (activeTab === 'Werkorders' && (defaultWorkorderFilterValues.locationId ?? 0) > 0) {
            setWorkorderFilterValues(defaultWorkorderFilterValues);
            dispatch(getAllWorkOrderAsync(defaultWorkorderFilterValues));
        }
        if (activeTab === 'ActiveWorkOrder' && (defaultActiveWorkorderFilterValues.locationId ?? 0) > 0) {
            setActiveWorkorderFilterValues(defaultActiveWorkorderFilterValues);
            dispatch(getAllActiveWorkOrderAsync(defaultActiveWorkorderFilterValues));
        }
        if (activeTab === 'WorkordersOnMove' &&
            currentUser &&
            rolePermissions &&
            rolePermissions[0].roleCategoryId !== RoleCategory.Projectleider &&
            (defaultOnMoveWorkorderFilterValues.locationId ?? 0) > 0) {
            setonMoveWorkorderFilterValues(defaultOnMoveWorkorderFilterValues);
            dispatch(getAllWorkOrdersOnMoveAsync(defaultOnMoveWorkorderFilterValues));
        }
        if (activeTab === 'WorkOrderDetails' && (defaultWorkordersDetailsFilterValues.locationId ?? 0) > 0) {
            setWorkordersDetailsFilterValues(defaultWorkordersDetailsFilterValues);
            dispatch(getAllWorkOrdersDetailsAsync(defaultWorkordersDetailsFilterValues));
        }
    }, [activeTab, workOrderRequest, activeWorkOrderRequest, dispatch]);
    function searchWorkOrderHandler(searchText) {
        updateWorkordersFilterValues({ ...updateWorkordersFilterValues, filter: searchText });
        dispatch(getAllWorkOrderAsync({ ...workorderFilterValues, filter: searchText, pageNumber: 1 }));
    }
    function searchActiveWorkOrderHandler(searchText) {
        upadteActiveWorkordersFilterValues({ ...activeworkorderFilterValues, filter: searchText });
        dispatch(getAllActiveWorkOrderAsync({ ...activeworkorderFilterValues, filter: searchText, pageNumber: 1 }));
    }
    function searchOnMoveWorkOrderHandler(searchText) {
        upadteOnMoveWorkordersFilterValues({ ...onMoveworkorderFilterValues, filter: searchText });
        dispatch(getAllWorkOrdersOnMoveAsync({ ...onMoveworkorderFilterValues, filter: searchText, pageNumber: 1 }));
    }
    function searchWorkOrdersDetailsHandler(searchText) {
        upadteWorkordersDetailFilterValues({ ...workordersDetailsFilterValues, filter: searchText });
        dispatch(getAllWorkOrdersDetailsAsync({ ...workordersDetailsFilterValues, filter: searchText, pageNumber: 1 }));
    }
    /*Workorder Grid */
    useEffect(() => {
        // dispatch(getAllWorkOrderAsync(workorderFilterValues));
        dispatch(getAllWorkOrderStatusAsync());
        dispatch(getAllJobCategoriesAsync());
    }, []);
    const updateWorkordersFilterValues = (newValues) => {
        setWorkorderFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    const upadteActiveWorkordersFilterValues = (newValues) => {
        setActiveWorkorderFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    const upadteOnMoveWorkordersFilterValues = (newValues) => {
        setonMoveWorkorderFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    const upadteWorkordersDetailFilterValues = (newValues) => {
        setWorkordersDetailsFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function onWorkOrderPageChange(pageNumber) {
        updateWorkordersFilterValues({ pageNumber });
        dispatch(getAllWorkOrderAsync({
            ...workorderFilterValues,
            pageNumber
        }));
    }
    function SortingHanlder(data) {
        updateWorkordersFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllWorkOrderAsync({
            ...workorderFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function ActiveWorkOrderSortingHanlder(data) {
        upadteActiveWorkordersFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllActiveWorkOrderAsync({
            ...activeworkorderFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function OnMoveWorkOrderSortingHanlder(data) {
        upadteOnMoveWorkordersFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
    }
    function OnWorkOrdersDetailsSortingHanlder(data) {
        upadteWorkordersDetailFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllWorkOrdersDetailsAsync({
            ...workordersDetailsFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function FilteringHandler(data) {
        data.pageNumber = 1;
        updateWorkordersFilterValues(data);
        dispatch(getAllWorkOrderAsync({
            ...workorderFilterValues,
            ...data
        }));
    }
    function ActiveWorkorderFilteringHandler(data) {
        data.pageNumber = 1;
        upadteActiveWorkordersFilterValues(data);
        dispatch(getAllActiveWorkOrderAsync({
            ...activeworkorderFilterValues,
            ...data
        }));
    }
    function OnMoveWorkorderFilteringHandler(data) {
        data.pageNumber = 1;
        upadteOnMoveWorkordersFilterValues(data);
        dispatch(getAllWorkOrdersOnMoveAsync({
            ...onMoveworkorderFilterValues,
            ...data
        }));
    }
    function OnWorkordersDetailsFilteringHandler(data) {
        data.pageNumber = 1;
        upadteWorkordersDetailFilterValues(data);
        dispatch(getAllWorkOrdersDetailsAsync({
            ...workordersDetailsFilterValues,
            ...data
        }));
    }
    function onActiveWorkOrdersPageChange(pageNumber) {
        upadteActiveWorkordersFilterValues({ pageNumber });
        dispatch(getAllActiveWorkOrderAsync({
            ...activeworkorderFilterValues,
            pageNumber
        }));
    }
    function onMoveWorkOrdersPageChange(pageNumber) {
        upadteOnMoveWorkordersFilterValues({ pageNumber });
        dispatch(getAllWorkOrdersOnMoveAsync({
            ...onMoveworkorderFilterValues,
            pageNumber
        }));
    }
    function onWorkOrdersDetailPageChange(pageNumber) {
        upadteWorkordersDetailFilterValues({ pageNumber });
        dispatch(getAllWorkOrdersDetailsAsync({
            ...workordersDetailsFilterValues,
            pageNumber
        }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '1rem'
                }, children: [_jsx("h4", { children: "Werkorders" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Werkorder', onClick: handleAddWorkOrderClick, isDisabled: !handleRolePermission(Permission.WERKORDER, PermissionType.Create) }) })] }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'Werkorders', title: 'Werkorders' }), _jsx(Tab, { eventKey: 'ActiveWorkOrder', title: 'Actieve Werkorders' }), _jsx(Tab, { eventKey: 'WorkordersOnMove', title: 'Jij Aan Zet' }), _jsx(Tab, { eventKey: 'WorkOrderDetails', title: 'Werkorders Detailoverzicht' })] }), _jsxs("div", { className: 'mt-0', children: [activeTab === 'Werkorders' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showWorkOrderGridHeader, onSearch: searchWorkOrderHandler }), _jsx(WorkOrderTable, { workOrders: workOrders?.items, onRowClick: onRowClick, onSorting: SortingHanlder, onFilter: FilteringHandler, workorderFilterValues: workorderFilterValues, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: workOrders && (_jsx(VnPagination, { currentPage: workOrders?.pageNumber, totalPages: workOrders?.totalPages, onPageChange: onWorkOrderPageChange })) })] })), activeTab === 'ActiveWorkOrder' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showWorkOrderGridHeader, onSearch: searchActiveWorkOrderHandler }), _jsx(ActiveWorkOrderTable, { workOrders: ActiveworkOrders?.items, onRowClick: onRowClick, onSorting: ActiveWorkOrderSortingHanlder, onFilter: ActiveWorkorderFilteringHandler, workorderFilterValues: activeworkorderFilterValues }), _jsx("div", { className: 'mt-3', children: ActiveworkOrders && (_jsx(VnPagination, { currentPage: ActiveworkOrders?.pageNumber, totalPages: ActiveworkOrders?.totalPages, onPageChange: onActiveWorkOrdersPageChange })) })] })), activeTab === 'WorkordersOnMove' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showWorkOrderGridHeader, onSearch: searchOnMoveWorkOrderHandler }), _jsx(WorkOrderOnMoveTable, { workOrders: workOrdersOnMove?.items, onRowClick: onRowClick, onSorting: OnMoveWorkOrderSortingHanlder, onFilter: OnMoveWorkorderFilteringHandler, workorderFilterValues: onMoveworkorderFilterValues }), _jsx("div", { className: 'mt-3', children: workOrdersOnMove && (_jsx(VnPagination, { currentPage: workOrdersOnMove?.pageNumber, totalPages: workOrdersOnMove?.totalPages, onPageChange: onMoveWorkOrdersPageChange })) })] })), activeTab === 'WorkOrderDetails' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showWorkOrderGridHeader, onSearch: searchWorkOrdersDetailsHandler }), _jsx(WorkOrderDetailsTable, { workOrdersDetails: workOrdersDetails?.items, onRowClick: onRowClick, onSorting: OnWorkOrdersDetailsSortingHanlder, onFilter: OnWorkordersDetailsFilteringHandler, workorderFilterValues: workordersDetailsFilterValues }), _jsx("div", { className: 'mt-3', children: workOrdersDetails && (_jsx(VnPagination, { currentPage: workOrdersDetails?.pageNumber, totalPages: workOrdersDetails?.totalPages, onPageChange: onWorkOrdersDetailPageChange })) })] }))] })] }));
};
export default WorkOrdersList;
